import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-arrow-down",
  "use": "app-icon-arrow-down-usage",
  "viewBox": "0 0 16 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 10\" id=\"app-icon-arrow-down\"><path d=\"M8 9.33l7.24-7.25L13.83.67 8 6.5 2.17.67.76 2.08z\" fill=\"#1B8ADB\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol